/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { LegalAgreementLanguage } from './';
import {
    LegalAgreementLanguageFromJSON,
    LegalAgreementLanguageFromJSONTyped,
    LegalAgreementLanguageToJSON,
} from './';

/**
 * 
 * @export
 * @interface AcceptUmbrellaCommercialContractRequest
 */
export interface AcceptUmbrellaCommercialContractRequest {
    /**
     * Published contract version displayed to the user.
     * @type {string}
     * @memberof AcceptUmbrellaCommercialContractRequest
     */
    versionId: string;
    /**
     * 
     * @type {LegalAgreementLanguage}
     * @memberof AcceptUmbrellaCommercialContractRequest
     */
    language: LegalAgreementLanguage;
}

/**
 * Check if a given object implements the AcceptUmbrellaCommercialContractRequest interface.
 */
export function instanceOfAcceptUmbrellaCommercialContractRequest(value: object): value is AcceptUmbrellaCommercialContractRequest {
    if (!('versionId' in value) || value['versionId'] === undefined) return false;
    if (!('language' in value) || value['language'] === undefined) return false;
    return true;
}

export function AcceptUmbrellaCommercialContractRequestFromJSON(json: any): AcceptUmbrellaCommercialContractRequest {
    return AcceptUmbrellaCommercialContractRequestFromJSONTyped(json, false);
}

export function AcceptUmbrellaCommercialContractRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AcceptUmbrellaCommercialContractRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'versionId': json['versionId'],
        'language': LegalAgreementLanguageFromJSON(json['language']),
    };
}

export function AcceptUmbrellaCommercialContractRequestToJSON(value?: AcceptUmbrellaCommercialContractRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'versionId': value['versionId'],
        'language': LegalAgreementLanguageToJSON(value['language']),
    };
}

